module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_10.292db7c0.jpg";